import { parseHostname } from '@ta-interaktiv/parse-hostname'
import {
  updateAge,
  updateEducation,
  updateGender,
  updatePublication
} from 'components/demographics/actions'
import { put, select, takeEvery } from 'redux-saga/effects'
import { uploadData } from 'sagas/uploadToFirebase/actions'
import { RootState } from 'stores'
import { Age } from 'types/age'
import { Education } from 'types/education'
import { Gender } from 'types/gender'
import { updateAnswer } from 'components/question/actions'
import { push } from 'connected-react-router'

function* conditionallyMoveToNextScreen() {
  const currentAge: Age = yield select(
    (state: RootState) => state.demographics.age
  )
  const currentGender: Gender = yield select(
    (state: RootState) => state.demographics.gender
  )

  const currentEducation: Education = yield select(
    (state: RootState) => state.demographics.education
  )

  const userAnswers = yield select((state: RootState) => state.answers)

  // Make sure that all the necessary data is set, only then allow moving forward
  if (
    currentAge &&
    currentGender &&
    currentEducation &&
    !userAnswers.includes(undefined)
  ) {
    yield put(updatePublication(parseHostname().publicationDomain))
    yield put(uploadData())
    yield put(push('/results'))
  }
}

export function* watchForDemographicsActions() {
  // Also watch for updateAnswer actions, so a player can go back answering unanswered question and is then immediately brought to the results if everything else is there
  yield takeEvery(
    [
      updateAge.toString(),
      updateGender.toString(),
      updateEducation.toString(),
      updateAnswer.toString()
    ],
    conditionallyMoveToNextScreen
  )
}
